import React, { useState } from 'react';
import styled, { keyframes } from "styled-components";
import { toast } from 'react-toastify';
import { FaMoneyBillWave } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

const PopUpConCuantoPagas = ({ TotalValue, popUpEntrega, setPopUpEntrega, setValorInput, color_botton, btnTextColor }) => {
    const [valorPay, setValorPay] = useState('');

    const enviarInformacion = (e) => {
        e.preventDefault();
        const numero = parseInt(TotalValue?.replace(/[^\d]/g, ""), 10);
        const ingresado = parseInt(valorPay, 10);
        if (isNaN(ingresado) || ingresado < numero) {
            toast.error(`El pago debe ser mayor o igual a ${TotalValue}`, {
                position: "top-center",
                autoClose: 4000,
            });
        } else {
            setValorInput(ingresado);
            setPopUpEntrega(false);
        }
    };

    if (!popUpEntrega) return null;

    return (
        <Overlay onClick={() => setPopUpEntrega(false)}>
            <Sheet onClick={(e) => e.stopPropagation()}>
                <Handle />
                <CloseBtn onClick={() => setPopUpEntrega(false)}>
                    <IoClose size={20} />
                </CloseBtn>

                <Header>
                    <IconCircle $color={color_botton}>
                        <FaMoneyBillWave size={22} color={color_botton || "#6C63FF"} />
                    </IconCircle>
                    <HeaderText>
                        <HeaderTitle>¿Con cuánto pagas?</HeaderTitle>
                        <HeaderSub>Total a pagar: <b>{TotalValue}</b></HeaderSub>
                    </HeaderText>
                </Header>

                <form onSubmit={enviarInformacion}>
                    <InputWrap>
                        <CurrencyLabel>$</CurrencyLabel>
                        <StyledInput
                            type="number"
                            placeholder="0"
                            min={1}
                            value={valorPay}
                            onChange={(e) => setValorPay(e.target.value)}
                            $color={color_botton}
                            autoFocus
                        />
                    </InputWrap>

                    <ConfirmBtn
                        type="submit"
                        $color={color_botton}
                        $textColor={btnTextColor}
                    >
                        Confirmar
                    </ConfirmBtn>
                </form>
            </Sheet>
        </Overlay>
    );
};

const slideUp = keyframes`
    from { transform: translateY(100%); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
`;
const fadeIn = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    backdrop-filter: blur(3px);
    z-index: 1200;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    animation: ${fadeIn} 0.2s ease;
`;

const Sheet = styled.div`
    width: 100%;
    max-width: 540px;
    background: #FFFFFF;
    border-radius: 28px 28px 0 0;
    padding: 12px 20px 36px 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    animation: ${slideUp} 0.3s cubic-bezier(0.34, 1.26, 0.64, 1);
    position: relative;
`;

const Handle = styled.div`
    width: 40px;
    height: 4px;
    background: #D8D8E0;
    border-radius: 99px;
    align-self: center;
    margin-bottom: 4px;
`;

const CloseBtn = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    background: #F3F2F4;
    border: none;
    border-radius: 99px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #5C5C7A;
    &:hover { background: #E8E8EF; }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding-right: 36px;
`;

const IconCircle = styled.div`
    width: 52px;
    height: 52px;
    border-radius: 16px;
    background: color-mix(in srgb, ${({ $color }) => $color || "#6C63FF"} 12%, transparent);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

const HeaderText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

const HeaderTitle = styled.p`
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #1A1A2E;
`;

const HeaderSub = styled.p`
    margin: 0;
    font-size: 13px;
    color: #8888A0;
`;

const InputWrap = styled.div`
    display: flex;
    align-items: center;
    background: #F7F7FA;
    border: 2px solid #EBEBF0;
    border-radius: 16px;
    padding: 0 16px;
    transition: border-color 0.18s;
    &:focus-within {
        border-color: ${({ $color }) => $color || "#6C63FF"};
        background: #FFFFFF;
    }
`;

const CurrencyLabel = styled.span`
    font-size: 24px;
    font-weight: 700;
    color: #AAAAB5;
    margin-right: 8px;
    user-select: none;
`;

const StyledInput = styled.input`
    flex: 1;
    height: 64px;
    border: none;
    background: transparent;
    font-size: 28px;
    font-weight: 700;
    color: #1A1A2E;
    outline: none;
    -webkit-appearance: none;
    &::placeholder { color: #D0D0DC; }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
`;

const ConfirmBtn = styled.button`
    width: 100%;
    height: 54px;
    border: none;
    border-radius: 16px;
    background: ${({ $color }) => $color || "#6C63FF"};
    color: ${({ $textColor }) => $textColor || "#FFFFFF"};
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.12s;
    box-shadow: 0 4px 16px color-mix(in srgb, ${({ $color }) => $color || "#6C63FF"} 35%, transparent);
    &:active { opacity: 0.88; transform: scale(0.98); }
`;

export default PopUpConCuantoPagas;
